module.exports = __webpack_public_path__ + "img/cut-03.9aa31ea2.jpg";